import { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { getReaction, setReaction } from '../lib/reactionsService';

function ReactionButtons({ contentKey, contentType, subject, title }) {
  const { user, isGuest } = useAuth();
  const [reaction, setReactionState] = useState(null); // null | 'like' | 'dislike'

  // Load any existing reaction on mount
  useEffect(() => {
    if (!contentKey) return;
    getReaction({ userId: user?.id, isGuest, contentKey })
      .then(({ data }) => setReactionState(data?.reaction || null));
  }, [contentKey, user?.id, isGuest]);

  const handleReact = async (picked) => {
    // Toggle off if clicking the same button again
    const next = reaction === picked ? null : picked;
    setReactionState(next);
    await setReaction({
      userId:      user?.id,
      isGuest,
      contentKey,
      contentType,
      subject,
      title,
      reaction:    next,
    });
  };

  return (
    <div className="reaction-btns">
      <button
        className={`reaction-btn ${reaction === 'like' ? 'reaction-btn--liked' : ''}`}
        onClick={() => handleReact('like')}
        title="I liked this"
        aria-label="Like"
      >
        👍
      </button>
      <button
        className={`reaction-btn ${reaction === 'dislike' ? 'reaction-btn--disliked' : ''}`}
        onClick={() => handleReact('dislike')}
        title="Not for me"
        aria-label="Dislike"
      >
        👎
      </button>
    </div>
  );
}

export default ReactionButtons;
